// extracted by mini-css-extract-plugin
export default {"changeTariffBtn":"c7GkL"};